import {
  DATA_CONNECTOR_GET_DATABASES_FOR_XATA_BEGIN,
  DATA_CONNECTOR_GET_DATABASES_FOR_XATA_SUCCESS,
  DATA_CONNECTOR_GET_DATABASES_FOR_XATA_FAILURE,
  DATA_CONNECTOR_GET_DATABASES_FOR_XATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function getDatabasesForXata(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_DATABASES_FOR_XATA_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xata/get-database`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_DATABASES_FOR_XATA_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_DATABASES_FOR_XATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetDatabasesForXataError() {
  return {
    type: DATA_CONNECTOR_GET_DATABASES_FOR_XATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_DATABASES_FOR_XATA_BEGIN:
      return {
        ...state,
        getDatabasesForXataPending: true,
        getDatabasesForXataError: null,
      };

    case DATA_CONNECTOR_GET_DATABASES_FOR_XATA_SUCCESS:
      return {
        ...state,
        getDatabasesForXataPending: false,
        getDatabasesForXataError: null,
        databasesByXata: action.data,
      };

    case DATA_CONNECTOR_GET_DATABASES_FOR_XATA_FAILURE:
      return {
        ...state,
        getDatabasesForXataPending: false,
        getDatabasesForXataError: action.data.error,
      };

    case DATA_CONNECTOR_GET_DATABASES_FOR_XATA_DISMISS_ERROR:
      return {
        ...state,
        getDatabasesForXataError: null,
      };

    default:
      return state;
  }
}
